"use client";

import { useEffect, useState } from "react";

interface DeltaBadgeProps {
  delta: number | null;
}

function formatDelta(value: number): string {
  const sign = value >= 0 ? "+" : "-";
  const abs = Math.abs(value);
  if (abs >= 1_000_000) return `${sign}$${(abs / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `${sign}$${(abs / 1_000).toFixed(0)}K`;
  return `${sign}$${abs.toFixed(0)}`;
}

export function DeltaBadge({ delta }: DeltaBadgeProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (delta === null || delta === 0) {
      setVisible(false);
      return;
    }
    setVisible(true);
    const timer = setTimeout(() => setVisible(false), 3000);
    return () => clearTimeout(timer);
  }, [delta]);

  if (!visible || delta === null || delta === 0) return null;

  const isPositive = delta >= 0;

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-bold transition-opacity duration-500 ${
        isPositive ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
      }`}
    >
      {formatDelta(delta)}
    </span>
  );
}
